export enum SettingsUserAvatarType {
  DISABLED = '',
  AVATAR_ONLY = 'avatar_only',
  PHOTO_ONLY = 'photo_only',
  AVATAR_AND_PHOTO = 'avatar_and_photo'
}
